import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { toggleModal, updateMessages } from 'apps/auth/actions/appAction';
import { setNewForm } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { PanelWithCheck } from 'apps/auth/components/common/components/PanelWithCheck/PanelWithCheck';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import Form from 'apps/auth/components/form-multi/Form';
import { getField } from 'apps/auth/components/form-multi/utils';
import CancelSubscriptionPopup from 'apps/auth/components/paysendPlus/subscriptionCancellation/CancelSubscriptionPopup';
import ConfirmCancellationModal from 'apps/auth/components/paysendPlus/subscriptionCancellation/ConfirmCancellationModal';
import BasePage from 'apps/auth/components/utils/BasePage';
import { PLUS_UNSUBSCRIBE_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_PLUS_MAIN_PAGE, AUTH_PLUS_UNSUBSCRIBE_ACTION } from 'apps/auth/constants/UrlConstants';
import { getDayMonthDate, resolveArguments } from 'apps/auth/helpers/utils';
import { useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';

const PlusUnsubscribePage = (props) => {
    const [cancellationReason, setCancellationReason] = useState([]);
    const [disabled, setDisabled] = useState(true);
    const popupRef = useRef(null);
    const submitRef = useRef(null);
    const { subscriptionInfo } = useExtra();
    const { lang } = useLanguage();
    const {
        plusCancelTitle,
        plusCancelSubtitle,
        plusCancelReason1,
        plusCancelReason2,
        plusCancelReason3,
        plusCancelReason4,
        plusCancelReason5,
        plusCancelPopupText,
        plusCancelPopupButton,
        plusCancelSecondScreenTitle,
        plusCancelSecondScreenInfo,
        continueButton,
    } = usePageMessages();
    const subscriptionEndDate = getDayMonthDate(subscriptionInfo.endPeriodTs, lang, 'long');

    useEffect(() => {
        setDisabled(cancellationReason.length <= 0);
    }, [cancellationReason]);

    const selectItem = (value) => {
        const reasonsArr = [...cancellationReason];
        const index = reasonsArr.indexOf(value);
        if (index > -1) {
            reasonsArr.splice(index, 1);
        } else {
            reasonsArr.push(value);
        }

        setCancellationReason(reasonsArr);

        const reasons = getField('reasons', reasonsArr);
        const products = getField('products', ['fee-free']);
        const fullUnsubscribe = getField('fullUnsubscribe', true);

        const fields = {
            [reasons.name]: reasons,
            [products.name]: products,
            [fullUnsubscribe.name]: fullUnsubscribe,
        };
        props.setNewForm(PLUS_UNSUBSCRIBE_FORM_NAME, fields);
    };

    const submitHandler = (fields, json) => {
        if (json && json.messageBodyMessages) {
            props.updateMessages(json.messageBodyMessages);
        }
    };

    const openCancelPopup = () => {
        popupRef.current?.open(
            <CancelSubscriptionPopup
                submitRef={submitRef}
                popupRef={popupRef}
                text={resolveArguments(plusCancelPopupText, subscriptionEndDate)}
                buttonText={plusCancelPopupButton}
            />,
        );
    };

    const reasons = [plusCancelReason1, plusCancelReason2, plusCancelReason3, plusCancelReason4, plusCancelReason5];
    return (
        <>
            <CommonPage backUrl={AUTH_PLUS_MAIN_PAGE} leftCloseIcon>
                <HeaderPanel title={plusCancelTitle} subtitle={plusCancelSubtitle} />
                <Form formName={PLUS_UNSUBSCRIBE_FORM_NAME} onSubmitHandler={submitHandler} action={AUTH_PLUS_UNSUBSCRIBE_ACTION} checkNotVisibleField={false}>
                    {reasons.map((reason, i) => {
                        return (
                            <PanelWithCheck
                                key={`reason_${i}`}
                                mainText={reason}
                                onClick={() => selectItem(reason)}
                                isSelected={cancellationReason.includes(reason)}
                            />
                        );
                    })}
                    <FixedBottomPanel isRightAligned>
                        <Button
                            type="button"
                            raised={true}
                            caption={continueButton}
                            onClick={() => {
                                props.toggleModal(
                                    true,
                                    <ConfirmCancellationModal
                                        openCancelPopup={openCancelPopup}
                                        continueButton={continueButton}
                                        title={plusCancelSecondScreenTitle}
                                        text={plusCancelSecondScreenInfo}
                                    />,
                                );
                            }}
                            ref={submitRef}
                            disabled={disabled}
                        />
                        <Button type="submit" variant="hidden" ref={submitRef} />
                    </FixedBottomPanel>
                </Form>
            </CommonPage>
            <PopupNew ref={popupRef} getPopupComponent={(component) => component} />
        </>
    );
};

export default connect(null, { toggleModal, setNewForm, updateMessages })(BasePage(PlusUnsubscribePage));
